// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2r2aa","footerBrand":"footer-module--footer-brand--182OI","footerInfo":"footer-module--footer-info--1znYG"};